<template>
  <div style="padding:20px;">
    <el-row>
      <el-col :span="24">
        <el-button style="padding: 0; margin: 20px" type="text" icon="el-icon-back" @click="backPrePage()">
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <el-row>
          <el-col :span="24">
            <el-form-item label="优惠券设置">
              <el-radio v-model="form.coupon_show" label="0">隐藏</el-radio>
              <el-radio v-model="form.coupon_show" label="1">显示</el-radio>
            </el-form-item>
          </el-col>
        </el-row>

        <template v-if="form.coupon_show == 1">
          <el-row>
            <el-col :span="24">
              <el-form-item label="一键领券赠课设置">
                <el-input size="medium" type="number" v-model="form.coupon_give_course" placeholder="课程ID" style="width:100px"></el-input>
                <span style="color:#909399"></span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="优惠券显示数量">
                <el-radio v-model="form.coupon_show_num" label="1">1张</el-radio>
                <el-radio v-model="form.coupon_show_num" label="2">2张</el-radio>
                <el-radio v-model="form.coupon_show_num" label="4">4张</el-radio>
                <el-radio v-model="form.coupon_show_num" label="6">6张</el-radio>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="18">
              <el-form-item label="优惠券列表">
                <template v-for="(item, index) in form.coupon_list">
                  <el-col :span="8" v-bind:key="index">
                    <el-input size="medium" type="number" v-model="item.coupon_id" placeholder="优惠券ID" style="width:100px"></el-input>
                    <el-input size="medium" type="number" v-model="item.num" placeholder="数量" style="width:80px"></el-input>
                    <div class="extend">{{ item.coupon_info.name }}，满{{ item.coupon_info.start }}减{{ item.coupon_info.reduce }}</div>
                    <div class="extend">{{ item.coupon_info.begin_at }} ~ {{ item.coupon_info.expire_at }}</div>
                    <!-- <template v-if="index > 5"> -->
                    <el-button v-bind:key="index" @click="form.coupon_list.splice(index, 1)" type="danger" icon="el-icon-delete" size="medium"></el-button>
                    <!-- </template> -->
                  </el-col>
                </template>
                <el-col :span="24">
                  <el-button @click="form.coupon_list.push({coupon_id:'',num:'',coupon_info:{start: 0,reduce: 0,name: ''}})" type="primary" icon="el-icon-plus" size="medium">增加
                  </el-button>
                  <span style="color:#909399"> 判断用户是否完成一键领取，是否完成领券判断"优惠券显示数量"+1张</span>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <el-divider></el-divider>

        <el-row>
          <el-col :span="24">
            <el-form-item label="课程列表">
              <template v-for="(item, index) in form.course_list">
                <el-col :span="6" v-bind:key="index">
                  <el-input size="medium" type="number" v-model="item.course_id" placeholder="课程ID" style="width:100px"></el-input>
                  <el-input size="medium" type="number" v-model="item.coupon_id" placeholder="优惠券ID" style="width:100px"></el-input>
                  <div class="extend">
                    <div>{{ item.course_info.title }}</div>
                    <div>售价：￥{{ item.course_info.discount_price }}, 券后价：￥{{ (item.course_info.discount_price - item.coupon_info.reduce).toFixed(2) }}</div>
                  </div>
                  <el-button v-bind:key="index" @click="form.course_list.splice(index, 1)" type="danger" icon="el-icon-delete" size="medium"></el-button>
                </el-col>
              </template>
              <el-col :span="24">
                <el-button @click="form.course_list.push({course_id:'',coupon_id:'',course_info:{title: '',discount_price: 0},coupon_info:{reduce: 0}})" type="primary" icon="el-icon-plus" size="medium">增加
                </el-button>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <el-row>
          <el-col :span="24">
            <el-form-item label="秒杀课程列表">
              <template v-for="(item, index) in form.flash_course_list">
                <el-col :span="6" v-bind:key="index">
                  <el-input size="medium" type="number" v-model="item.flash_id" placeholder="秒杀ID" style="width:100px"></el-input>
                  <el-button v-bind:key="index" @click="form.flash_course_list.splice(index, 1)" type="danger" icon="el-icon-delete" size="medium"></el-button>
                </el-col>
              </template>
              <el-col :span="24">
                <el-button @click="form.flash_course_list.push({flash_id:''})" type="primary" icon="el-icon-plus" size="medium">增加
                </el-button>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider></el-divider>

        <el-row>
          <el-col :span="24">
            <el-form-item label="直播间ID">
              <el-input size="medium" type="number" v-model="form.live_id" placeholder="课程ID" style="width:100px"></el-input>
              <span style="color:#909399"> 不填则隐藏</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="线下主推课ID & 优惠券ID">
              <template v-for="(item, index) in form.offline_main_course_list">
                <el-col :span="6" v-bind:key="index">
                  <el-input size="medium" type="number" v-model="item.course_id" placeholder="课程ID" style="width:100px"></el-input>
                  <el-input size="medium" type="number" v-model="item.coupon_id" placeholder="优惠券ID" style="width:100px"></el-input>
                  <div class="extend">
                    <div>{{ item.course_info.title }}</div>
                    <div>售价：￥{{ item.course_info.discount_price }}, 券后价：￥{{ (item.course_info.discount_price - item.coupon_info.reduce).toFixed(2) }}</div>
                  </div>
                  <el-button v-bind:key="index" @click="form.offline_main_course_list.splice(index, 1)" type="danger" icon="el-icon-delete" size="medium"></el-button>
                </el-col>
              </template>
              <el-col :span="24">
                <el-button @click="form.offline_main_course_list.push({course_id:'',coupon_id:'',course_info:{title: '',discount_price: 0},coupon_info:{reduce: 0}})" type="primary" icon="el-icon-plus" size="medium">增加
                </el-button>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="线上主推课ID & 优惠券ID">
              <template v-for="(item, index) in form.online_main_course_list">
                <el-col :span="6" v-bind:key="index">
                  <el-input size="medium" type="number" v-model="item.course_id" placeholder="课程ID" style="width:100px"></el-input>
                  <el-input size="medium" type="number" v-model="item.coupon_id" placeholder="优惠券ID" style="width:100px"></el-input>
                  <div class="extend">
                    <div>{{ item.course_info.title }}</div>
                    <div>售价：￥{{ item.course_info.discount_price }}, 券后价：￥{{ (item.course_info.discount_price - item.coupon_info.reduce).toFixed(2) }}</div>
                  </div>
                  <el-button v-bind:key="index" @click="form.online_main_course_list.splice(index, 1)" type="danger" icon="el-icon-delete" size="medium"></el-button>
                </el-col>
              </template>
              <el-col :span="24">
                <el-button @click="form.online_main_course_list.push({course_id:'',coupon_id:'',course_info:{title: '',discount_price: 0},coupon_info:{reduce: 0}})" type="primary" icon="el-icon-plus" size="medium">增加
                </el-button>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="主推课ID & 优惠券ID">
              <el-input size="medium" type="number" v-model="form.main_course_id" placeholder="主推课ID" style="width:100px"></el-input>
              <el-input size="medium" type="number" v-model="form.main_course_coupon_id" placeholder="优惠券ID" style="width:100px"></el-input>
              <span style="color:#909399"> 不填写课程id则隐藏该模块，如填写优惠券，倒计时读取填写优惠券的使用截止时间，不填写优惠券不显示倒计时</span>
            </el-form-item>
          </el-col>
        </el-row> -->

        <el-row>
          <el-col :span="24">
            <el-form-item label="会员模块设置">
              <el-radio v-model="form.vip_module_show" label="0">隐藏</el-radio>
              <el-radio v-model="form.vip_module_show" label="1">显示</el-radio>
              <span style="color:#909399"> 隐藏会员模块则赠送设置不再生效，同一生效时间内请勿设置多种买赠方式</span>
            </el-form-item>
            <template v-if="form.vip_module_show == 1">
              <el-form-item label="会员年卡赠送会员">
                <el-select class="search-el" size="small" v-model="form.vip_give_vip_id" placeholder="类型">
                  <el-option label="不赠送会员" value=""></el-option>
                  <el-option label="半月会员" value="3"></el-option>
                  <el-option label="月卡会员" value="4"></el-option>
                  <el-option label="季卡会员" value="6"></el-option>
                  <el-option label="半年会员" value="8"></el-option>
                  <el-option label="幸福会员" value="10"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="会员年卡赠送课程ID">
                <el-input size="medium" type="number" v-model="form.vip_give_course_id" placeholder="赠送ID" style="width:100px"></el-input>
              </el-form-item>
              <el-form-item label="会员购买按钮角标文字">
                <el-input size="medium" v-model="form.vip_discount_price" placeholder="主推课ID" style="width:400px"></el-input>
              </el-form-item>
            </template>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="电商模块设置">
              <el-radio v-model="form.product_module_show" label="0">隐藏</el-radio>
              <el-radio v-model="form.product_module_show" label="1">显示秒杀列表</el-radio>
              <el-radio v-model="form.product_module_show" label="2">自选秒杀商品</el-radio>
            </el-form-item>
          </el-col>

          <template v-if="form.product_module_show == 2">
            <el-col :span="24">
              <el-form-item label="秒杀商品列表">
                <template v-for="(item, index) in form.flash_product_list">
                  <el-col :span="6" v-bind:key="index">
                    <el-input size="medium" type="number" v-model="item.flash_id" placeholder="秒杀ID" style="width:100px"></el-input>
                    <el-button v-bind:key="index" @click="form.flash_product_list.splice(index, 1)" type="danger" icon="el-icon-delete" size="medium"></el-button>
                  </el-col>
                </template>
                <el-col :span="24">
                  <el-button @click="form.flash_product_list.push({flash_id:''})" type="primary" icon="el-icon-plus" size="medium">增加
                  </el-button>
                </el-col>
              </el-form-item>
            </el-col>
          </template>
        </el-row>

      
        <el-form-item>
          <el-button type="primary" :loading="onSaveLoading" @click="onSave">保存</el-button>
          <el-button @click="backPrePage()">取消</el-button>
        </el-form-item>
      </el-form>
      
    </el-row>
  </div>
</template>

<script>
import { getInfo, savePageIdInfo } from '@/api/activityCustom'

export default {
  data: function () {
    return {
      id: '',
      info: {},
      form: {
        background_color: '',
        background_image: '',
        coupon_mask: '',
        live_background_image: '',
        main_courses_image: '',
        courses_list_image: '',
        activity_marker_image: '',
        vip_image: '',
        vip_sell_image: '',
        product_image: '',
        share_image: '',
        receive_coupon_button: '',
        main_course_button: '',
        vip_button: '',
        course_list_button: '',
      },
      ossAction: '',
      formLoading: false,
      onSaveLoading: false,
    }
  },
  created: function () {
    this.id = this.$route.query.id
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.formLoading = true
      getInfo({
        id: this.id,
      }).then((response) => {
        this.formLoading = false
        this.info = response.data
        let tempForm = response.data.page_ids
        let tempCouponList = tempForm.coupon_list
        let tempFlashCourseList = typeof tempForm.flash_course_list == 'undefined' ? [] : tempForm.flash_course_list
        let tempFlashProductList = typeof tempForm.flash_product_list == 'undefined' ? [] : tempForm.flash_product_list

        // for (let i = 0; i < 6; i++) {
        //   if (typeof tempCouponList[i] == 'undefined') {
        //     tempCouponList.push({ num: '', coupon_id: '', coupon_info: {} })
        //   }
        // }

        if (tempFlashCourseList.length == 0) {
          tempFlashCourseList[0] = { flash_id: '' }
        }

        if (tempFlashProductList.length == 0) {
          tempFlashProductList[0] = { flash_id: '' }
        }

        if (tempCouponList.length == 0) {
          tempCouponList.push({ num: '', coupon_id: '', coupon_info: {} })
        }

        for (let j = 0; j < tempCouponList.length; j++) {
          if (typeof response.data.extend_coupon_list[tempCouponList[j].coupon_id] != 'undefined') {
            tempCouponList[j]['coupon_info'] = response.data.extend_coupon_list[tempCouponList[j].coupon_id];
          } else {
            tempCouponList[j]['coupon_info'] = { start: 0, reduce: 0, name: '' }
          }
        }

        var handleCourseCouponInfo = function(list){
          for (let n = 0; n < list.length; n++) {
            if (typeof response.data.extend_coupon_list[list[n].coupon_id] != 'undefined') {
              list[n]['coupon_info'] = response.data.extend_coupon_list[list[n].coupon_id];
            } else {
              list[n]['coupon_info'] = { reduce: 0 }
            }
            if (typeof response.data.extend_course_list[list[n].course_id] != 'undefined') {
              list[n]['course_info'] = response.data.extend_course_list[list[n].course_id]
            } else {
              list[n]['course_info'] = { title: '', discount_price: 0 }
            }
          }
          return list;
        }


        // for (let n = 0; n < tempCourseList.length; n++) {
        //   if (typeof response.data.extend_coupon_list[tempCourseList[n].coupon_id] != 'undefined') {
        //     tempCourseList[n]['coupon_info'] = response.data.extend_coupon_list[tempCourseList[n].coupon_id];
        //   } else {
        //     tempCourseList[n]['coupon_info'] = { reduce: 0 }
        //   }
        //   if (typeof response.data.extend_course_list[tempCourseList[n].course_id] != 'undefined') {
        //     tempCourseList[n]['course_info'] = response.data.extend_course_list[tempCourseList[n].course_id]
        //   } else {
        //     tempCourseList[n]['course_info'] = { title: '', discount_price: 0 }
        //   }
        // }

        tempForm.coupon_list = tempCouponList
        tempForm.course_list = handleCourseCouponInfo(tempForm.course_list);
        tempForm.online_main_course_list = handleCourseCouponInfo(tempForm.online_main_course_list);
        tempForm.offline_main_course_list = handleCourseCouponInfo(tempForm.offline_main_course_list);
        tempForm.flash_course_list = tempFlashCourseList
        tempForm.flash_product_list = tempFlashProductList

        this.form = tempForm
      })
    },
    uploadSuccess(value) {
      this.form[value.formName] = value.fileUrl
    },
    onSave() {
      this.onSaveLoading = true
      let that = this
      savePageIdInfo({
        id: this.id,
        form: this.form,
      }).then((res) => {
        that.onSaveLoading = false
        if (res.code == 1) {
          that.$message({
            showClose: true,
            duration: 6000,
            message: '保存成功',
            type: 'success',
          })

          this.getInfo()
          // that.backPrePage();
        }
      })
    },
    backPrePage() {
      this.$router.go(-1)
    },
  },
}
</script>
<style>
.el-divider--horizontal {
  margin: 0 0 24px 0;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 100px;
  min-height: 70px;
  display: block;
}

.extend {
  color: #909399;
  line-height: 20px;
  display: flex;
  flex-direction: column;
}
.extend div {
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>